/**
 * @generated SignedSource<<30ceca0e45541660d936d0c59de21c2f>>
 * @relayHash fb1aea8bdb58b6d481d231e39c304270
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fb1aea8bdb58b6d481d231e39c304270

import { ConcreteRequest } from 'relay-runtime';
export type AirwallexBankAccountSupport = "LOCAL_BANK_VIA_LOCAL_RAIL" | "LOCAL_BANK_VIA_SWIFT_ONLY" | "NONE" | "USA_BANK_ONLY" | "%future added value";
export type AirwallexPayoutAccountPrerequisite = "PERSONA_VERIFICATION" | "%future added value";
export type Alpha2CountryCodes = "AD" | "AE" | "AF" | "AG" | "AI" | "AL" | "AM" | "AO" | "AQ" | "AR" | "AS" | "AT" | "AU" | "AW" | "AX" | "AZ" | "BA" | "BB" | "BD" | "BE" | "BF" | "BG" | "BH" | "BI" | "BJ" | "BL" | "BM" | "BN" | "BO" | "BQ" | "BR" | "BS" | "BT" | "BV" | "BW" | "BY" | "BZ" | "CA" | "CC" | "CD" | "CF" | "CG" | "CH" | "CI" | "CK" | "CL" | "CM" | "CN" | "CO" | "CR" | "CU" | "CV" | "CW" | "CX" | "CY" | "CZ" | "DE" | "DJ" | "DK" | "DM" | "DO" | "DZ" | "EC" | "EE" | "EG" | "EH" | "ER" | "ES" | "ET" | "FI" | "FJ" | "FK" | "FM" | "FO" | "FR" | "GA" | "GB" | "GD" | "GE" | "GF" | "GG" | "GH" | "GI" | "GL" | "GM" | "GN" | "GP" | "GQ" | "GR" | "GS" | "GT" | "GU" | "GW" | "GY" | "HK" | "HM" | "HN" | "HR" | "HT" | "HU" | "ID" | "IE" | "IL" | "IM" | "IN" | "IO" | "IQ" | "IR" | "IS" | "IT" | "JE" | "JM" | "JO" | "JP" | "KE" | "KG" | "KH" | "KI" | "KM" | "KN" | "KP" | "KR" | "KW" | "KY" | "KZ" | "LA" | "LB" | "LC" | "LI" | "LK" | "LR" | "LS" | "LT" | "LU" | "LV" | "LY" | "MA" | "MC" | "MD" | "ME" | "MF" | "MG" | "MH" | "MK" | "ML" | "MM" | "MN" | "MO" | "MP" | "MQ" | "MR" | "MS" | "MT" | "MU" | "MV" | "MW" | "MX" | "MY" | "MZ" | "NA" | "NC" | "NE" | "NF" | "NG" | "NI" | "NL" | "NO" | "NP" | "NR" | "NU" | "NZ" | "OM" | "PA" | "PE" | "PF" | "PG" | "PH" | "PK" | "PL" | "PM" | "PN" | "PR" | "PS" | "PT" | "PW" | "PY" | "QA" | "RE" | "RO" | "RS" | "RU" | "RW" | "SA" | "SB" | "SC" | "SD" | "SE" | "SG" | "SH" | "SI" | "SJ" | "SK" | "SL" | "SM" | "SN" | "SO" | "SR" | "SS" | "ST" | "SV" | "SX" | "SY" | "SZ" | "TC" | "TD" | "TF" | "TG" | "TH" | "TJ" | "TK" | "TL" | "TM" | "TN" | "TO" | "TR" | "TT" | "TV" | "TW" | "TZ" | "UA" | "UG" | "UM" | "US" | "UY" | "UZ" | "VA" | "VC" | "VE" | "VG" | "VI" | "VN" | "VU" | "WF" | "WS" | "XK" | "YE" | "YT" | "ZA" | "ZM" | "ZW" | "%future added value";
export type PayoutAccountEligibilityStatus = "ELIGIBLE" | "INELIGIBLE_COUNTRY_NOT_SUPPORTED" | "INELIGIBLE_COUNTRY_SANCTIONED" | "%future added value";
export type StripeBankAccountPayoutAccountFlowContraInAppPrerequisite = "PERSONA_VERIFICATION" | "%future added value";
export type StripeBankAccountPayoutAccountFlowStripeHostedPrerequisite = "AGREE_TO_RECIPIENT_AGREEMENT" | "%future added value";
export type StripeDebitCardPayoutAccountPrerequisite = "AGREE_TO_RECIPIENT_AGREEMENT" | "BANK_ACCOUNT" | "PERSONA_VERIFICATION" | "%future added value";
export type UsdcPayoutAccountPrerequisite = "PERSONA_VERIFICATION" | "%future added value";
export type InitialStateLoaderPayoutSetup_Query$variables = Record<PropertyKey, never>;
export type InitialStateLoaderPayoutSetup_Query$data = {
  readonly visitor: {
    readonly userAccount: {
      readonly businessOperationsCountry: {
        readonly canEdit: boolean;
        readonly countryCode: Alpha2CountryCodes | null;
      };
      readonly payoutAccountEligibility: {
        readonly airwallexPayouts: {
          readonly airwallexBankAccountSupport: AirwallexBankAccountSupport;
          readonly eligibilityStatus: PayoutAccountEligibilityStatus;
          readonly prerequisite: AirwallexPayoutAccountPrerequisite | null;
        };
        readonly payoneerPayouts: {
          readonly eligibilityStatus: PayoutAccountEligibilityStatus;
        };
        readonly paypalPayouts: {
          readonly eligibilityStatus: PayoutAccountEligibilityStatus;
        };
        readonly stripeBankAccountPayouts: {
          readonly eligibilityStatus: PayoutAccountEligibilityStatus;
          readonly flow: {
            readonly __typename: "StripeBankAccountPayoutAccountEligibilityFlowContraInApp";
            readonly prerequisiteInApp: StripeBankAccountPayoutAccountFlowContraInAppPrerequisite | null;
          } | {
            readonly __typename: "StripeBankAccountPayoutAccountEligibilityFlowStripeHosted";
            readonly prerequisiteStripeHosted: StripeBankAccountPayoutAccountFlowStripeHostedPrerequisite | null;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
        };
        readonly stripeDebitCardPayouts: {
          readonly eligibilityStatus: PayoutAccountEligibilityStatus;
          readonly prerequisite: StripeDebitCardPayoutAccountPrerequisite | null;
        };
        readonly usdcPayouts: {
          readonly eligibilityStatus: PayoutAccountEligibilityStatus;
          readonly prerequisite: UsdcPayoutAccountPrerequisite | null;
        };
      };
      readonly stripeAccount: {
        readonly requiresConnectOnboardingAction: boolean;
      };
      readonly verifiedIdentity: {
        readonly location: string | null;
        readonly locationMatchesUserAccountLocation: boolean;
      } | null;
    } | null;
  };
};
export type InitialStateLoaderPayoutSetup_Query = {
  response: InitialStateLoaderPayoutSetup_Query$data;
  variables: InitialStateLoaderPayoutSetup_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "StripeAccount",
  "kind": "LinkedField",
  "name": "stripeAccount",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requiresConnectOnboardingAction",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessOperationsCountry",
  "kind": "LinkedField",
  "name": "businessOperationsCountry",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countryCode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eligibilityStatus",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prerequisite",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AirwallexPayoutAccountEligibility",
  "kind": "LinkedField",
  "name": "airwallexPayouts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "airwallexBankAccountSupport",
      "storageKey": null
    },
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "StripeDebitCardPayoutAccountEligibility",
  "kind": "LinkedField",
  "name": "stripeDebitCardPayouts",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UsdcPayoutAccountEligibility",
  "kind": "LinkedField",
  "name": "usdcPayouts",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v8 = [
  (v2/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PaypalPayoutAccountEligibility",
  "kind": "LinkedField",
  "name": "paypalPayouts",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PayoneerPayoutAccountEligibility",
  "kind": "LinkedField",
  "name": "payoneerPayouts",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": "prerequisiteInApp",
  "args": null,
  "kind": "ScalarField",
  "name": "prerequisite",
  "storageKey": null
},
v13 = {
  "alias": "prerequisiteStripeHosted",
  "args": null,
  "kind": "ScalarField",
  "name": "prerequisite",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationMatchesUserAccountLocation",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "InitialStateLoaderPayoutSetup_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Visitor",
        "kind": "LinkedField",
        "name": "visitor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PayoutAccountEligibility",
                "kind": "LinkedField",
                "name": "payoutAccountEligibility",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StripeBankAccountPayoutAccountEligibility",
                    "kind": "LinkedField",
                    "name": "stripeBankAccountPayouts",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "flow",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v11/*: any*/),
                              (v12/*: any*/)
                            ],
                            "type": "StripeBankAccountPayoutAccountEligibilityFlowContraInApp",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v11/*: any*/),
                              (v13/*: any*/)
                            ],
                            "type": "StripeBankAccountPayoutAccountEligibilityFlowStripeHosted",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VerifiedIdentity",
                "kind": "LinkedField",
                "name": "verifiedIdentity",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "InitialStateLoaderPayoutSetup_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Visitor",
        "kind": "LinkedField",
        "name": "visitor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PayoutAccountEligibility",
                "kind": "LinkedField",
                "name": "payoutAccountEligibility",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StripeBankAccountPayoutAccountEligibility",
                    "kind": "LinkedField",
                    "name": "stripeBankAccountPayouts",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "flow",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v12/*: any*/)
                            ],
                            "type": "StripeBankAccountPayoutAccountEligibilityFlowContraInApp",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/)
                            ],
                            "type": "StripeBankAccountPayoutAccountEligibilityFlowStripeHosted",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VerifiedIdentity",
                "kind": "LinkedField",
                "name": "verifiedIdentity",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "fb1aea8bdb58b6d481d231e39c304270",
    "metadata": {},
    "name": "InitialStateLoaderPayoutSetup_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8888942946236b892798f8944855dd55";

export default node;
